import { FC } from 'react';
import { Button, Drawer, Menu } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Paths } from 'utils/constants';

import { useAppSelector, useTranslate } from 'hooks';

import { LogoType } from '../LogoType';
import { LanguageSwitcher } from '../LanguageSwitcher';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import styles from './index.module.scss';

type SideBarProps = {
	onClose: () => void;
	visible: boolean;
};

export const SideBar: FC<SideBarProps> = ({ onClose, visible }) => {
	const { registerText, loginText } = useTranslate(['registerText', 'loginText']);

	const menu = useAppSelector((state) => state.settings.menu);
	const registrationStep = useAppSelector((state) => state.registration.step);

	const location = useLocation();

	const navigate = useNavigate();

	const isRegistration = location.pathname === Paths.REGISTER;
	return (
		<Drawer
			className={styles.sidebar}
			title={
				<div className={styles.title}>
					<LogoType />
					<Button onClick={onClose} className={styles.close} type="link" icon={<CloseIcon />} />
				</div>
			}
			width="100%"
			closable={false}
			onClose={onClose}
			open={visible}
		>
			<div className={styles.content}>
				<div>
					<Menu className={styles.menu}>
						{menu?.header?.menu?.map((item) => (
							<Menu.Item className={styles.menuItem} key={item.url}>
								<a href={item.url}>{item.title}</a>
							</Menu.Item>
						))}

						{isRegistration && registrationStep === 1 ? (
							''
						) : (
							<Menu.Item className={styles.menuItem} key="Log in">
								<Button
									className={styles.menuItemBtn}
									type="link"
									onClick={() => {
										navigate(isRegistration ? Paths.REGISTER : '/');
										onClose();
									}}
								>
									{isRegistration ? registerText : loginText}
								</Button>
							</Menu.Item>
						)}
					</Menu>

					<Link to={isRegistration ? '/' : Paths.REGISTER} className={styles.link}>
						<Button type="default" className={styles.button}>
							{isRegistration ? loginText : registerText}
						</Button>
					</Link>
				</div>
				<div className={styles.language}>
					<LanguageSwitcher />
				</div>
			</div>
		</Drawer>
	);
};
